// 편집기 오픈 타입(EditorOpenType) UI를 노출하는 채널 목록
// 0605 ohprintme → 굿즈굿즈(channel9) 추가
// 0611 ohprintme → cafe24_ohprintme로 채널명 변경
// 0612 webling_qa 추가, 개발/운영 분기 삭제 (채널 ID 기준 비교)
export const EDITOR_OPEN_TYPE_VISIBLE_CHANNEL_IDS: readonly string[] = [
  'channel9',
  'webling_qa',
  'cafe24_ohprintme',
  'ohprintme',
  'snaps',
];

export const isEditorOpenTypeVisibleChannel = (channelId?: string): boolean =>
  !!channelId && EDITOR_OPEN_TYPE_VISIBLE_CHANNEL_IDS.includes(channelId);
